import { render, staticRenderFns } from "./RouteLegActions.vue?vue&type=template&id=06d7482a&scoped=true&"
import script from "./RouteLegActions.vue?vue&type=script&lang=ts&"
export * from "./RouteLegActions.vue?vue&type=script&lang=ts&"
import style0 from "./RouteLegActions.vue?vue&type=style&index=0&id=06d7482a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d7482a",
  null
  
)

export default component.exports